export default __webpack_public_path__ + "static/media/BCPCResults.df2aae64.png";